import BaseAPI from './base/base-api';

class AdminProcedureAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'DeclareAPI';
	controllerName = 'adminprocedure';
}

export default new AdminProcedureAPI();
